<div>
  <label for="">{{
    totalVagasConfirmadas > 1 ? "Vincular INE's à Vagas" : "Vincular INE à Vaga"
  }}</label>
</div>

<div class="p-4 mt-4 mb-4" style="background-color: rgba(244, 244, 244, 1)">
  Status do progresso:
  <strong style="color: rgba(12, 50, 111, 1)"
    >{{ totalVagasIne() }} de {{ totalVagasConfirmadas }}</strong
  >
  vagas preenchidas
</div>

<form [formGroup]="form">
  <div formArrayName="vagasEquipe">
    @for (
      modalidadeVaga of vagas;
      track modalidadeVaga.idModalidade;
      let i = $index
    ) {
      <app-card-collapse
        [titulo]="'Seção ' + (i + 1) + ' - ' + modalidadeVaga.nomeModalidade"
        [isCollapsed]="false"
      >
        <hr />

        <div class="row" [formArrayName]="i">
          @for (vaga of modalidadeVaga.vagas; track vaga.id; let j = $index) {
            <div class="col-12 mt-4">
              <label for=""
                >Vaga {{ j + 1 }} -
                <span class="badge rounded-pill text-bg-primary">{{
                  vaga.vagaPrograma.tipoEquipe.nome
                }}</span></label
              >

              <div [formGroupName]="j" class="col-6 pl-0">
                <label for="">Selecione o INE da Equipe*</label>
                <br-select-custom
                  placeholder="Selecione"
                  formControlName="ine"
                  [options]="getEquipesVagas(i, j)"
                  (ngModelChange)="setEquipe($event, i, j)"
                ></br-select-custom>
                @if (!getIne(i, j)) {
                  <div class="text-danger mt-1">
                    INE obrigatório para prosseguir
                  </div>
                }
              </div>

              @if (getIne(i, j)) {
                <div class="info-ine p-2 mt-2">
                  <div class="info-ine-header">
                    <label
                      ><div class="fa fa-circle-check"></div>
                      Dados carregados automaticamente</label
                    >
                  </div>

                  <hr />

                  <div class="row">
                    <div class="col-3">
                      <label for="">CNES</label>
                      <div>{{ getIne(i, j)?.coCnes }}</div>
                    </div>

                    <div class="col-9">
                      <label for="">Nome do Estabelecimento</label>
                      <div>{{ getIne(i, j)?.nomeEstabelecimento }}</div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </app-card-collapse>
    }
  </div>
</form>

<hr />

<div class="d-flex justify-content-between">
  <br-button
    [emphasis]="'secondary'"
    (click)="prev()"
    [isLoading]="isSubmitting"
    [ariaLabel]="'Voltar'"
  >
    Voltar
  </br-button>
  <br-button
    [emphasis]="'primary'"
    [isLoading]="isSubmitting"
    [disabled]="form.invalid || this.equipes.length === 0"
    (click)="next()"
    [ariaLabel]="'Próximo'"
  >
    Próximo</br-button
  >
</div>
